<script>
import { ArrowLeftIcon } from 'vue-feather-icons'
// import router from "@/router/router.js";

export default {
  components: { ArrowLeftIcon }
}
</script>
<template lang="pug">
button.btn(type="button" v-ea-click="() => { $router.push('/') }")
  arrow-left-icon(size="1.5x")
</template>

<style lang="scss" scoped>
button {
  height: 12vh;
  padding: 1.4rem 4rem 1.4rem 2.6rem;
}
</style>
